export default {"src":"/_next/static/media/company5.466011fe.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};